export const SERVICES = [
  {
    id: "kitchen",
    title: "Architectural Kitchen Atelier",
    short: "Kitchen Remodeling",
    description:
      "Custom cabinetry, waterfall marble islands, integrated appliances, and tailored lighting design.",
    image:
      "https://images.unsplash.com/photo-1682888813913-e13f18692019?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBraXRjaGVuJTIwcmVtb2RlbGluZyUyMG1vZGVybiUyMGludGVyaW9yfGVufDB8fHx8MTc5MjMzNzE0OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "bathroom",
    title: "Luxury Spa Bathrooms",
    short: "Bathroom Renovation",
    description:
      "Bookmatched marble slabs, curbless wet-rooms, brushed bronze hardware, and floor-to-ceiling glass.",
    image:
      "https://images.pexels.com/photos/8082223/pexels-photo-8082223.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "deck",
    title: "Outdoor Decks & Living",
    short: "Decking & Outdoor",
    description:
      "Ipe hardwood decking, hidden structural fasteners, integrated firescapes, and indoor-outdoor transitions.",
    image:
      "https://images.unsplash.com/photo-1574120583586-de8847ae992c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxhcmNoaXRlY3R1cmFsJTIwd29vZGVuJTIwZGVjayUyMHBhdGlvJTIwcmVub3ZhdGlvbiUyMG91dGRvb3J8ZW58MHx8fHwxNzkyMzM3MTQ5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "painting",
    title: "Artisan Architectural Painting",
    short: "Architectural Painting",
    description:
      "Roman clay finishes, lime wash, micro-cement textures, acoustic treatments, and precision trim.",
    image:
      "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxpbnRlcmlvciUyMHBhaW50aW5nJTIwbHV4dXJ5JTIwYXJjaGl0ZWN0dXJhbCUyMHdhbGwlMjBmaW5pc2h8ZW58MHx8fHwxNzkyMzM3MTU2fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const PROJECTS = [
  {
    id: "proj-1",
    slug: "the-bellevue-kitchen-atelier",
    title: "The Bellevue Kitchen Atelier",
    category: "kitchen",
    category_label: "Kitchen Remodeling",
    location: "Bella Vista, Philadelphia",
    year: "2025",
    duration: "10 Weeks",
    investment: "$185,000",
    image_url:
      "https://images.unsplash.com/photo-1639405069836-f82aa6dcb900?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBraXRjaGVuJTIwcmVtb2RlbGluZyUyMG1vZGVybiUyMGludGVyaW9yfGVufDB8fHx8MTc5MjMzNzE0OXww&ixlib=rb-4.1.0&q=85",
    summary:
      "Complete structural gut and reconfiguration converting a cramped 1980s layout into a high-visibility architectural cooking space with concealed pantry.",
    specs: [
      "Calacatta Viola Marble",
      "Custom Smoked Oak Joinery",
      "Gaggenau induction suite",
      "Integrated brass reveal details",
    ],
    challenge:
      "Removing a central load-bearing wall required inserting a 24-foot concealed steel I-beam flush with the ceiling.",
    solution:
      "Designed custom shadow gaps around all wall junctions and flush-mounted cabinetry for a seamless monolithic aesthetic.",
  },
  {
    id: "proj-2",
    slug: "hall-bathroom-renewal",
    title: "Hall Bathroom Renewal",
    category: "bathroom",
    category_label: "Bathroom Renovation",
    location: "Private Residence",
    year: "2026",
    duration: "—",
    investment: "On request",
    image_url:
      "https://customer-assets-lqy194kg.emergentagent.net/job_brick-and-beam/artifacts/f5db72c228436cb1_IMG-20260914-WA0012.webp",
    gallery: [
      "https://customer-assets-lqy194kg.emergentagent.net/job_brick-and-beam/artifacts/f5db72c228436cb1_IMG-20260914-WA0012.webp",
      "https://customer-assets-lqy194kg.emergentagent.net/job_brick-and-beam/artifacts/79a8273dd3ab9cf9_IMG-20260914-WA0014.webp",
    ],
    summary:
      "Full hall-bathroom renovation: new sliding glass shower enclosure with marble-look tile surround, a crisp white vanity with brushed-gold waterfall faucet, and fresh tile flooring throughout.",
    specs: [
      "Sliding glass shower enclosure",
      "Marble-look tile surround",
      "White shaker vanity",
      "Brushed-gold waterfall faucet",
    ],
    challenge:
      "A compact footprint that needed a full shower, vanity and storage without the room feeling smaller.",
    solution:
      "Light-toned large-format tile, a clear sliding enclosure and a clean-lined vanity keep the room bright and open.",
  },
  {
    id: "proj-3",
    slug: "curbside-stone-masonry",
    title: "Curbside Stone & Masonry",
    category: "deck",
    category_label: "Exterior & Masonry",
    location: "Private Residence",
    year: "2026",
    duration: "—",
    investment: "On request",
    image_url:
      "https://customer-assets-lqy194kg.emergentagent.net/job_brick-and-beam/artifacts/e3573e1fc8d0a166_IMG-20260914-WA0008.webp",
    gallery: [
      "https://customer-assets-lqy194kg.emergentagent.net/job_brick-and-beam/artifacts/a678b3a503b466dd_IMG-20260914-WA0006.webp",
      "https://customer-assets-lqy194kg.emergentagent.net/job_brick-and-beam/artifacts/e3573e1fc8d0a166_IMG-20260914-WA0008.webp",
      "https://customer-assets-lqy194kg.emergentagent.net/job_brick-and-beam/artifacts/50b1605851273706_IMG-20260914-WA0007.webp",
    ],
    summary:
      "Complete curbside exterior transformation: stacked-stone veneer planter walls, a matching stone accent facade with new entry door and window trim, and a freshly poured concrete patio and walkway.",
    specs: [
      "Stacked-stone veneer cladding",
      "Raised masonry planter beds",
      "New steel entry door & trim",
      "Fresh-poured concrete flatwork",
    ],
    challenge:
      "Tying new masonry and concrete work into the existing brick facade and sidewalk grades without visible transitions.",
    solution:
      "Matched stone coursing to the brick datum lines and screeded the new flatwork to meet existing walkway elevations flush.",
  },
  {
    id: "proj-4",
    slug: "minimalist-gallery-wall-finishes",
    title: "Monolith Living Room & Lime Wash",
    category: "painting",
    category_label: "Architectural Painting",
    location: "Rittenhouse Square, Philadelphia",
    year: "2025",
    duration: "3 Weeks",
    investment: "$48,000",
    image_url:
      "https://images.unsplash.com/photo-1704040686413-2c607dbd2f06?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxpbnRlcmlvciUyMHBhaW50aW5nJTIwbHV4dXJ5JTIwYXJjaGl0ZWN0dXJhbCUyMHdhbGwlMjBmaW5pc2h8ZW58MHx8fHwxNzkyMzM3MTQ2fDA&ixlib=rb-4.1.0&q=85",
    summary:
      "Multi-layer Italian plaster and matte lime wash application across 3,500 sq ft of open-plan living space.",
    specs: [
      "Bauwerk Lime Wash",
      "Hand-troweled Venetian Plaster",
      "Dustless Preparation",
      "Acoustic Sealer",
    ],
    challenge:
      "Achieving consistent clouding pattern across 22-foot soaring double-height walls.",
    solution:
      "Utilized a specialized two-artisan synchronized application method with custom staging.",
  },
  {
    id: "proj-5",
    slug: "highlands-estate-exterior-renovation",
    title: "Highlands Architectural Facade",
    category: "deck",
    category_label: "Exterior & Structure",
    location: "Chestnut Hill, Philadelphia",
    year: "2024",
    duration: "14 Weeks",
    investment: "$310,000",
    image_url:
      "https://images.unsplash.com/photo-1762811054947-605b20298615?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjBhcmNoaXRlY3R1cmFsJTIwaG9tZSUyMGV4dGVyaW9yJTIwcmVub3ZhdGlvbiUyMG5pZ2h0JTIwbGlnaHRpbmd8ZW58MHx8fHwxNzkyMzM3MTU2fDA&ixlib=rb-4.1.0&q=85",
    summary:
      "Complete exterior envelope modernization featuring thermowood cladding, architectural steel entry accents, and automated architectural lighting.",
    specs: [
      "Thermally Modified Ash Siding",
      "Zinc Roof Trim",
      "Architectural Downlighting",
      "Custom Entrance Door",
    ],
    challenge:
      "Retrofitting high-performance thermal insulation without altering window casing depths.",
    solution:
      "Applied Aerogel ultra-thin insulation panels behind rain-screen wood battens.",
  },
  {
    id: "proj-6",
    slug: "marina-master-suite-bath",
    title: "Marina Dual Vanity Master Suite",
    category: "bathroom",
    category_label: "Bathroom Renovation",
    location: "Fishtown, Philadelphia",
    year: "2025",
    duration: "5 Weeks",
    investment: "$85,000",
    image_url:
      "https://images.unsplash.com/photo-1638799869566-b17fa794c4de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjBiYXRocm9vbSUyMHJlbm92YXRpb24lMjBkZXNpZ258ZW58MHx8fHwxNzkyMzM3MTQ5fDA&ixlib=rb-4.1.0&q=85",
    summary:
      "Contemporary dual-vanity master suite featuring backlit LED mirrors, floating teak vanity, and a freestanding oval soaking tub.",
    specs: [
      "Teak Floating Vanity",
      "Backlit Smart Mirrors",
      "Soaking Tub by Laufen",
      "Concealed Drain Channels",
    ],
    challenge:
      "Integrating structural tub weight reinforcement into existing subfloor.",
    solution:
      "Engineered sistered floor joists with steel cross-bracing beneath the tub footprint.",
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1728721529009-bfaab6fcc8e6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBsdXh1cnklMjBhcmNoaXRlY3R1cmFsJTIwaG9tZSUyMGV4dGVyaW9yJTIwcmVub3ZhdGlvbiUyMG5pZ2h0JTIwbGlnaHRpbmd8ZW58MHx8fHwxNzkyMzM3MTU2fDA&ixlib=rb-4.1.0&q=85";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
